import {DefinitionsList as DefinitionsListShared} from '@github-ui/custom-properties-core/components/DefinitionsList'
import {PropertiesPageTabs} from '@github-ui/custom-properties-core/components/PropertiesPageTabs'
import type {OrgCustomPropertiesListPagePayload} from '@github-ui/custom-properties-types'
import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {Pagination} from '@primer/react'
import {useState} from 'react'

import {DefinitionsPageHeader} from '../components/PropertiesHeaderPageTabs'
import {usePropertiesListResults} from '../hooks/use-properties-list'
import {useEditPropertyPathBuilder} from '../hooks/use-property-details-paths'
import {DefinitionsFilter} from './DefinitionsFilter'

export function OrgCustomPropertiesListPage() {
  const {permissions, ownDefinitionsCount, ...payload} = useRoutePayload<OrgCustomPropertiesListPagePayload>()
  const showFilterDialog = useFeatureFlag('repos_list_show_filter_dialog')
  const getPropertyDetailsPath = useEditPropertyPathBuilder()

  const [filterQuery, setFilterQuery] = useState('')

  const {
    payload: {totalCount, pageCount, definitions},
    currentPage,
    fetchResults,
  } = usePropertiesListResults({initialPayload: payload})

  return (
    <>
      <DefinitionsPageHeader ownDefinitionsCount={ownDefinitionsCount} permissions={permissions} />
      {permissions === 'all' && (
        <PropertiesPageTabs initialActiveTab="properties" definitionsCount={totalCount} className="pr-mb-3" />
      )}
      <DefinitionsFilter
        className="pr-mb-3"
        variant={showFilterDialog ? 'full' : 'input'}
        filterValue={filterQuery}
        onChange={setFilterQuery}
        onSubmit={request => fetchResults({page: 1, filterQuery: request.raw})}
      />

      <DefinitionsListShared
        totalCount={totalCount}
        definitions={definitions}
        renderItem={definition => (
          <DefinitionsListShared.Item
            key={definition.propertyName}
            settingsLevel="org"
            definition={definition}
            linkTo={getPropertyDetailsPath(definition.propertyName)}
          />
        )}
      />

      {pageCount > 1 && (
        <Pagination
          currentPage={currentPage}
          pageCount={pageCount}
          onPageChange={(e, page) => {
            e.preventDefault() // Prevent click event from navigating
            fetchResults({page, filterQuery})
          }}
        />
      )}
    </>
  )
}
